"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Cells = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.Cells = styled_components_1.default.div `
  & > * {
    margin: 20px 0;
  }

  & {
    font-family: "Source Sans Pro", Helvetica Neue, Helvetica, sans-serif;
    font-size: 16px;
    background-color: var(--theme-app-bg);
    color: var(--theme-app-fg);

    padding-bottom: 10px;
  }
`;
exports.Cells.displayName = "Cells";
exports.default = exports.Cells;
//# sourceMappingURL=cells.js.map